import { ButtonPropsWithLabel } from 'src/components/Dialog';
import { Stack } from 'src/components/Stack';
import { Typography } from 'src/components/Typography';

import { BlockingReasonList } from './BlockingReasonList';
import { UserDetails } from './UserDetails';
import { BlockingReasonVariant, CheckinBlockerUser } from './_types';

export function UserContent({
  users,
  getBlockerActions,
  showUserDetails = false,
  showUserName = true,
  variant = 'checkin',
}: {
  users: CheckinBlockerUser[];
  getBlockerActions?: (
    user: CheckinBlockerUser,
    blocker: CheckinBlockerUser['blockers'][number],
    index: number
  ) => ButtonPropsWithLabel[] | undefined;
  showUserDetails?: boolean;
  showUserName?: boolean;
  variant?: BlockingReasonVariant;
}) {
  return (
    <Stack spacing={3} sx={{ width: '100%' }}>
      {users.map((user, index) => (
        <Stack
          key={
            user.id != null && user.id !== ''
              ? user.id
              : `checkin-blocker-${index}`
          }
          spacing={2}
          sx={{ width: '100%' }}
        >
          {(user.name ?? '').trim() && showUserName ? (
            showUserDetails ? (
              <UserDetails user={user} />
            ) : (
              <Typography variant="h6">{user.name}</Typography>
            )
          ) : null}

          <BlockingReasonList
            blockers={user.blockers}
            getBlockerActions={(blocker, index) =>
              getBlockerActions?.(user, blocker, index)
            }
            userId={user.id ?? ''}
            variant={variant}
          />
        </Stack>
      ))}
    </Stack>
  );
}
